import { useQuery, QueryClient } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys.js";

import { postcodeSuburbMapping } from "../../mapping/postcodeSuburbMapping.js";

//** Axios request */
import { request } from "../../utilities/axios-utils.js";

//----------------------------------------------------------------

const fetchSuburb = async (requestData) => {
  try {
    const { accessToken, locality } = { ...requestData };

    if (!locality || locality.length < 3) return [];

    const response = await request({
      url: `/findSuburbs/${locality}`,
      method: "GET",
      accessToken: accessToken,
    });

    let returnResponse = postcodeSuburbMapping([response.data.suburbs]);

    return returnResponse;
  } catch (ex) {
    console.error(ex);
  }
};

export const useFindSuburb = (requestData) =>
  useQuery({
    queryKey: [queryKeys.FIND_SUBURB, requestData?.locality],
    queryFn: async () => await fetchSuburb(requestData),
    refetchOnWindowFocus: false,
    enabled: !!requestData?.locality,
  });
